import styled, { css } from 'styled-components';

const sizes = {
  small: '800px',
  medium: '1000px',
  large: '1200px',
  full: '100%'
};

const paddings = {
  none: '0',
  small: '1rem',
  medium: '2rem',
  large: '4rem'
};

const Container = styled.div`
  width: 100%;
  max-width: ${props => sizes[props.size] || sizes.large};
  margin: 0 auto;
  padding-left: ${props => paddings[props.padding] || paddings.small};
  padding-right: ${props => paddings[props.padding] || paddings.small};
  
  ${props => props.flex && css`
    display: flex;
    flex-direction: ${props.direction || 'row'};
    align-items: ${props.alignItems || 'stretch'};
    justify-content: ${props.justifyContent || 'flex-start'};
    gap: ${props.gap || '0'};
  `}

  ${props => props.grid && css`
    display: grid;
    grid-template-columns: ${props.columns || 'repeat(12, 1fr)'};
    gap: ${props.gap || '1rem'};
  `}
`;

export default Container;